import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import PrivateRoute from './components/PrivateRoute';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import MainDashboard from './pages/MainDashboard';
import Accounting from './pages/Accounting';
import Sales from './pages/Sales';
import Marketing from './pages/Marketing';
import Production from './pages/Production';
import Shipping from './pages/Shipping';
import Profile from './pages/Profile';
import Stock from './pages/Stock';
import HR from './pages/HR';
import Orders from './pages/Orders';
import UserManagement from './pages/UserManagement';
import SystemAdmin from './pages/SystemAdmin';
import Messages from './pages/Messages';
import NotificationAlertManager from './components/NotificationAlertManager';
import './App.css';

// Yeni bileşen: Kullanıcıyı yetkisi olan ilk modüle yönlendirir
const InitialRedirect = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  
  if (loading) return null;

  // URL'de system-admin geçiyorsa ASLA müdahale etme
  if (window.location.hash.includes('system-admin') || location.pathname.includes('system-admin')) {
    return null;
  }

  if (!user) return <Navigate to="/login" replace />;
  
  // Herkes portal (modül seçim ekranı) sayfasına yönlendirilir
  return <Navigate to="/portal" replace />;
};

function App() {
  useEffect(() => {
    if (!window.location.hash && window.location.pathname === '/system-admin') {
      window.location.replace(`${window.location.origin}/#/system-admin`);
    }
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <NotificationAlertManager />
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
                success: {
                  duration: 3000,
                  iconTheme: {
                    primary: '#10b981',
                    secondary: '#fff',
                  },
                },
                error: {
                  duration: 5000,
                  iconTheme: {
                    primary: '#ef4444',
                    secondary: '#fff',
                  },
                },
              }}
            />
            <Routes>
              <Route path="/system-admin" element={<SystemAdmin />} />
              <Route path="/login" element={<Login />} />
              <Route path="/" element={
                <PrivateRoute>
                  <InitialRedirect />
                </PrivateRoute>
              } />
              <Route path="/portal" element={
                <PrivateRoute>
                  <MainDashboard />
                </PrivateRoute>
              } />
              <Route path="/dashboard" element={
                <PrivateRoute>
                  <ProtectedRoute permission="dashboard">
                    <Layout>
                      <Dashboard />
                    </Layout>
                  </ProtectedRoute>
                </PrivateRoute>
              } />
              <Route path="/accounting/*" element={
                <PrivateRoute>
                  <ProtectedRoute permission="accounting">
                    <Layout>
                      <Accounting />
                    </Layout>
                  </ProtectedRoute>
                </PrivateRoute>
              } />
              <Route path="/sales/*" element={
                <PrivateRoute>
                  <ProtectedRoute permission="sales">
                    <Layout>
                      <Sales />
                    </Layout>
                  </ProtectedRoute>
                </PrivateRoute>
              } />
              <Route path="/marketing/*" element={
                <PrivateRoute>
                  <ProtectedRoute permission="marketing">
                    <Layout>
                      <Marketing />
                    </Layout>
                  </ProtectedRoute>
                </PrivateRoute>
              } />
              <Route path="/production/*" element={
                <PrivateRoute>
                  <ProtectedRoute permission="production">
                    <Layout>
                      <Production />
                    </Layout>
                  </ProtectedRoute>
                </PrivateRoute>
              } />
              <Route path="/shipping/*" element={
                <PrivateRoute>
                  <ProtectedRoute permission="shipping">
                    <Layout>
                      <Shipping />
                    </Layout>
                  </ProtectedRoute>
                </PrivateRoute>
              } />
              <Route path="/stock/*" element={
                <PrivateRoute>
                  <ProtectedRoute permission="stock">
                    <Layout>
                      <Stock />
                    </Layout>
                  </ProtectedRoute>
                </PrivateRoute>
              } />
              <Route path="/hr/*" element={
                <PrivateRoute>
                  <ProtectedRoute permission="hr">
                    <Layout>
                      <HR />
                    </Layout>
                  </ProtectedRoute>
                </PrivateRoute>
              } />
              <Route path="/orders/*" element={
                <PrivateRoute>
                  <ProtectedRoute permission="orders">
                    <Layout>
                      <Orders />
                    </Layout>
                  </ProtectedRoute>
                </PrivateRoute>
              } />
              <Route path="/users/*" element={
                <PrivateRoute>
                  <ProtectedRoute permission="users">
                    <Layout>
                      <UserManagement />
                    </Layout>
                  </ProtectedRoute>
                </PrivateRoute>
              } />
              <Route path="/profile" element={
                <PrivateRoute>
                  <Layout>
                    <Profile />
                  </Layout>
                </PrivateRoute>
              } />
              <Route path="/messages" element={
                <PrivateRoute>
                  <Layout>
                    <Messages />
                  </Layout>
                </PrivateRoute>
              } />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
